import Accordion from "@/components/Accordion";
import React from "react";
import TextInput from "../../TextInput";
import { LanguageConfigModel } from "@/pages/Messaging/types";
import { ChatWindow } from "../../types";

interface Props {
  onExpanded(): void;
  workingChatWindow: ChatWindow;
  setWorkingChatWindow: (chatWindow: ChatWindow) => void;
}

export function WhatsApp(props: Props) {
  const workingLanguageConfig = props.workingChatWindow.languageConfig || {};

  const updateLanguageConfig = (updates: Partial<LanguageConfigModel>) => {
    props.setWorkingChatWindow({
      ...props.workingChatWindow,
      languageConfig: {
        ...workingLanguageConfig,
        ...updates
      }
    });
  };

  return (
    <Accordion.Item eventKey="whatsapp" onExpanded={() => props.onExpanded()}>
      <Accordion.Header>
        <Accordion.Title>WhatsApp</Accordion.Title>
      </Accordion.Header>
      <Accordion.Body>
        <div className="mb-2">
          <div className="text-sm font-medium mb-2">Header Title</div>
          <TextInput
            value={workingLanguageConfig.whatsAppTitle}
            setValue={(value) => updateLanguageConfig({ whatsAppTitle: value })}
            showEmojiButton={false}
            maxWordCount={undefined}
          />
          <div className="text-sm font-medium my-2">Header Sub Title</div>
          <TextInput
            value={workingLanguageConfig.whatsAppSubTitle}
            setValue={(value) =>
              updateLanguageConfig({ whatsAppSubTitle: value })
            }
            showEmojiButton={false}
            maxWordCount={undefined}
          />
          <div className="text-sm font-medium my-2">Response Time Message</div>
          <TextInput
            value={workingLanguageConfig.whatsAppResponseTime}
            setValue={(value) =>
              updateLanguageConfig({ whatsAppResponseTime: value })
            }
            showEmojiButton={false}
            maxWordCount={undefined}
          />
          <div className="text-sm font-medium my-2">Form Header</div>
          <TextInput
            value={workingLanguageConfig.whatsAppFormHeader}
            setValue={(value) =>
              updateLanguageConfig({ whatsAppFormHeader: value })
            }
            showEmojiButton={false}
            maxWordCount={undefined}
          />
          <div className="text-sm font-medium my-2">Form Footer</div>
          <TextInput
            value={workingLanguageConfig.whatsAppFormFooter}
            setValue={(value) =>
              updateLanguageConfig({ whatsAppFormFooter: value })
            }
            showEmojiButton={false}
            maxWordCount={undefined}
          />
          <div className="text-sm font-medium my-2">Button Message</div>
          <TextInput
            value={workingLanguageConfig.whatsAppButton}
            setValue={(value) =>
              updateLanguageConfig({ whatsAppButton: value })
            }
            showEmojiButton={false}
            maxWordCount={undefined}
          />
        </div>
      </Accordion.Body>
    </Accordion.Item>
  );
}
